<template>
    <div class="base-info">
        <!-- <div class="title">
            <img src="@/modules/sn//assets/images/icon-barcode.png" />
            <span> 条码字符串：{{ barcodeNo }} </span>
        </div> -->
        <div class="car-box">
            <card title="产品信息" :list="baseInformationList" />
        </div>
        <div class="car-box">
            <card title="生产信息" :list="prdInformationList" />
        </div>
        <div class="car-box">
            <card title="品质信息" :list="qualityInformationList" />
        </div>
    </div>
</template>

<script>
import {
    getProductInfo,
    getProduceInfo,
    getQualityInfo
} from '@/modules/sn/api/lcbsManagement.js';
import card from './card';
export default {
    name: 'BaseInfo',
    components: {
        card
    },
    props: {
        barcodeNo: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {
            baseInformationList: [
                {
                    label: '产品编码：',
                    value: '',
                    key: 'itemCode'
                },
                {
                    label: '产品描述：',
                    key: 'itemName',
                    value: ''
                },
                {
                    label: '生产日期：',
                    key: 'prodDate',
                    value: ''
                }
            ],
            prdInformationList: [
                {
                    label: '工厂组织：',
                    value: '',
                    key: 'toOrgName'
                },
                {
                    label: '生产工单：',
                    key: 'sourceSysOrderNumber',
                    value: ''
                },
                {
                    label: '大箱条码：',
                    key: 'boxBarcodeNo',
                    value: ''
                },
                {
                    label: '返修机原条码：',
                    key: 'judgeBarcode',
                    value: ''
                },
                {
                    label: '电控码：',
                    key: 'qrcode',
                    value: ''
                },
                {
                    label: '订单生产编码：',
                    key: 'productOrderNo',
                    value: ''
                }
            ],
            qualityInformationList: [
                {
                    label: '工单数量：',
                    value: '',
                    key: 'moQty'
                },
                {
                    label: '下线完工数：',
                    key: 'moFinishQty',
                    value: ''
                },
                {
                    label: '车间：',
                    key: 'workshopDesc',
                    value: ''
                },
                {
                    label: '产线信息：',
                    key: 'lineDesc',
                    value: ''
                },
                {
                    label: '销往地：',
                    key: 'saleTo',
                    value: ''
                },
                {
                    label: '客户订单：',
                    key: 'customerOrder',
                    value: ''
                },
                {
                    label: '条码状态：',
                    key: 'barcodeStatus',
                    value: ''
                },
                {
                    label: '检验状态：',
                    key: 'inspectResut',
                    value: ''
                },
                {
                    label: '冻结状态：',
                    key: 'frozenStatus',
                    value: ''
                },
                {
                    label: '下线时间：',
                    key: 'datetimeOffline',
                    value: ''
                }
            ]
        };
    },
    mounted() {
        this.getData(getProductInfo, 'baseInformationList');
        this.getData(getProduceInfo, 'prdInformationList');
        this.getData(getQualityInfo, 'qualityInformationList');
    },
    methods: {
        getData(reuqset, key) {
            reuqset({ barcodeNo: this.barcodeNo }).then((res) =>
                this.setData(key, res)
            );
        },
        // 接口可能返回code但没有data情况
        setData(key, res) {
            if (res && +res.code === 0) {
                if (!res.data) return;
                this[key].forEach((item) => {
                    item.value =
                        !res.data[item.key] || res.data[item.key] === ''
                            ? '--'
                            : res.data[item.key];
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.base-info {
    padding: 0 15px 15px;
    height: calc(100vh - 190px);
    overflow: auto;
    // .title {
    //     display: flex;
    //     align-items: center;
    //     font-size: 14px;
    //     font-weight: 700;
    // }
    .car-box {
        margin-bottom: 20px;
    }
    // img {
    //     width: 20px;
    //     margin-right: 5px;
    // }
}
</style>
